export const AUTO_PAY_AMOUNT_CHANGED = "AUTO_PAY_AMOOUNT_CHANGED";
export const AUTO_PAY_DEATILS_LOADED = "AUTO_PAY_DEATILS_LOADED";
export const BILL_REMINDERS_DEATILS_LOADED = "BILL_REMINDERS_DEATILS_LOADED";
export const BILL_DEATILS_LOADED = "BILL_DEATILS_LOADED";
export const AUTO_PAY_METHOD_CHANGED = "AUTO_PAY_METHOD_CHANGED";
export const AUTO_PAY_CHANGED = "AUTO_PAY_CHANGED";
export const PAGE_MODE_CHANGED = "PAGE_MODE_CHANGED";
export const RESET_INIT_STATE = "RESET_INIT_STATE";
